import { createSlice } from "@reduxjs/toolkit";

export const reducer_bedsteadsArray = createSlice({
    name:"macAlertsArray",
    initialState:{
        bedsteads_array:[]
    },
    reducers:{
        ADD_BEDSTEADS_ARRAY:(state, action)=>{
            if(action.payload!==null){
                state.bedsteads_array=action.payload
            }
        }
    },

})

export const {
    ADD_BEDSTEADS_ARRAY
} = reducer_bedsteadsArray.actions

export default reducer_bedsteadsArray.reducer